var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-service-wrapper"},[_c('HomeService2025'),_vm._v(" "),_c('hr',{staticClass:"line-break"}),_vm._v(" "),_c('HomeServicePack2025',{attrs:{"box":_vm.box}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }